import React, { useEffect, useState } from "react";
import Back from "../../../components/back";
import OrderDetails from "./order-details";
import { useParams } from "react-router-dom";
import useRequest from "../../../components/hooks/use-request";
import OrderTimeline from "./order-timeline";

interface Order {
  id: string;
  orderId: string;
  merchantName: string | null;
  merchantBusinessName: string | null;
  merchantPhoneNumber: string | null;
  merchantEmail: string | null;
  merchantSocialMediaHandle: string | null;
  merchantSocialMediaPlatform: string | null;
  socialMediaPlatform: string | null;
  buyerName: string;
  buyerPhoneNumber: string;
  buyerEmail: string;
  buyerSocialMediaHandle: string | null;
  buyerSocialMediaPlatform: string | null;
  createdBy: string;
  status: string;
  code: string;
  created_at: string;
  updated_at: string;
}

interface Transaction {
  id: string;
  amount: number;
  type: string;
  status: string;
  created_at: string;
  order: Order;
}

const TransactionDetails: React.FC = () => {
  const [transaction, setTransaction] = useState<Transaction>({
    id: "",
    amount: 0,
    type: "",
    status: "",
    created_at: "",
    order: {
      id: "",
      orderId: "",
      merchantName: null,
      merchantBusinessName: null,
      merchantPhoneNumber: null,
      merchantEmail: null,
      merchantSocialMediaHandle: null,
      merchantSocialMediaPlatform: null,
      socialMediaPlatform: null,
      buyerName: "",
      buyerPhoneNumber: "",
      buyerEmail: "",
      buyerSocialMediaHandle: null,
      buyerSocialMediaPlatform: null,
      createdBy: "",
      status: "",
      code: "",
      created_at: "",
      updated_at: "",
    },
  });

  const { id } = useParams<{ id: string }>();
  const { makeRequest: getTransactionById } = useRequest(
    `/transactions/${id}`,
    "GET"
  );

  useEffect(() => {
    const fetchData = async () => {
      const [response] = await getTransactionById();
      setTransaction(response?.data?.transaction || []);
    };
    fetchData();
  }, [id]);

  return (
    <>
      <div className="flex gap-5 mt-5">
        <Back />
        <h2 className="text-[24px] font-bold">Transaction Details</h2>
      </div>
      <div className="flex justify-between gap-10">
        <OrderTimeline transactions={transaction} />
        <OrderDetails transactions={transaction} />
      </div>
    </>
  );
};

export default TransactionDetails;
